declare var $: any;
declare var CircleType: any;
import { InviteFunctions } from './invites';
import { CookieFunctions } from './cookiemessage';
import { QuoteFunctions } from './quotes';
declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build
declare const VERSION: string; // The value is supplied by Webpack during the build
declare const LIVE_URL_IMAGES: string; // The value is supplied by Webpack during the build
import * as Sentry from '@sentry/browser';
declare let gtag: Function;
// import { Integrations } from '@sentry/tracing';
// import { RewriteFrames } from '@sentry/integrations';

if (!IS_DEV_BUILD) {

  Sentry.init({
    dsn: 'https://68dc5a7baeed492e81f53b29c14868e7@o460993.ingest.sentry.io/5462155',
    release: `v-${VERSION}`,
    // integrations: [new Integrations.BrowserTracing()],
    // tracesSampleRate: 0.25,
    // debug: true,
    // beforeSend(event) {
    //  alert('Event!');
    //  console.log(event);
    //  return event;
    // },
  });

} else {

  // Sentry.init({
  //  dsn: 'https://a14734e2f34e483fb65ac3c289bec28e@o460993.ingest.sentry.io/5462176',
  //  release: `v-${VERSION}`,
  //  integrations: [new Integrations.BrowserTracing()],
  //  tracesSampleRate: 1.0,
  // });
}

export class Course {

  public inviteFunctions: InviteFunctions;
  public cookieFunctions: CookieFunctions;
  public quoteFunctions: QuoteFunctions;
  private resizeTask: any = null;
  private resizeListener: any = null;
  private resizeListenerEvent: any = null;
  private isTouch: boolean = false;
  private touchstartListener: any = null;
  private touchstartListenerEvent: any = null;
  private liveUrlImages: string = LIVE_URL_IMAGES;

  constructor() {
    this.inviteFunctions = new InviteFunctions;
    this.cookieFunctions = new CookieFunctions;
    this.quoteFunctions = new QuoteFunctions;
    console.log('Courses invoked!');
  }

  setupTouchListener() {

    this.touchstartListener = () => {
      if (this.resizeListenerEvent) {
        window.removeEventListener('resize', this.resizeListenerEvent);
      }
      window.addEventListener('orientationchange', this.resizeListenerEvent);
      this.isTouch = true;
      if (this.touchstartListenerEvent) {
        window.removeEventListener('touchstart', this.touchstartListenerEvent);
      }
    };

    this.touchstartListenerEvent = this.touchstartListener.bind(this);
    window.addEventListener('touchstart', this.touchstartListenerEvent);
  }

  setupResizeListener() {

    this.resizeListener = () => {

      if (this.resizeTask !== null) {
        clearTimeout(this.resizeTask);
      }

      this.resizeTask = setTimeout(
        () => {
          this.resizeTask = null;
          this.quoteFunctions.recreateSiema();
          this.sizeItems();
        },
        delay);

    };

    const delay = 100;
    this.resizeListenerEvent = this.resizeListener.bind(this);
    window.addEventListener('resize', this.resizeListenerEvent);
  }

  getCookie(name: String) {
    const v = document.cookie?.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  }

  analytics() {
    // only submit to analytics if cookie consent allows it!
    // TODO - test event correctly sent to Analytics if cookie consent
    // and not sent if no consent
    const consentCookie = this.getCookie('cpt-cookie-consent');

    if (!consentCookie || consentCookie.indexOf('-analytics') === -1) {
      return;
    }

    // console.log(window.location);
    // console.log(document.title);

    if (typeof (gtag) !== 'undefined') {
      gtag('js', new Date());
      gtag('config', 'G-PMPJFNGGSE');
      // gtag('event', 'page_view', {
        // page_title: document.title,
        //// page_location: window.location.pathname,
        // page_path: window.location.pathname,
      // });
    }
  }

  sizeElements(elements: HTMLElement[], height: number) {

    for (const element of elements as HTMLElement[]) {
      element.style.height = height > 0 ? `${height.toString()}px` : 'auto';
      element.classList.remove('name-unsized');
    }
  }

  sizeItems(windowResize?: boolean) {

    // this.clearEvents();
    if (document.getElementById('courses')) {

      let imagesLoaded: number = 0;
      let imgHeightValue: string = 'auto';
      let nameHeightValue: string = 'auto';

      let sized: boolean = false;
      let retry: boolean = false;

      setTimeout(
        () => {
          let maxH: number = 0;
          let lastLeft: number = 0;
          let lastRow: HTMLElement[] = [];
          let itemNo: number = 0;
          const names = document.getElementsByClassName('resources-flex__list-item-name');
          let el: HTMLElement | null = null;

          if (windowResize) {
            for (const name of names as any) {
              el = name;
              if (el) {
                el.style.height = 'auto';
              }
            }
          }

          for (const name of names as any) {
            itemNo += 1;
            el = name;

            if (el && (el.style.height === '' || el.style.height === 'auto')) {

              if (el.parentElement?.parentElement?.parentElement) {

                const thisLeft = el.parentElement.parentElement.parentElement.offsetLeft;

                if (thisLeft < lastLeft) {
                  // update previous row's element heights
                  this.sizeElements(lastRow, maxH);
                  lastRow = [];
                  maxH = 0;
                }
                lastRow.push(el);
                lastLeft = thisLeft;
              }
              maxH = el.offsetHeight > maxH ?
                el.offsetHeight : maxH;

              if (maxH === 0) {
                retry = true;
                break;
              }
            }

            if (retry) {
              // TODO - remove in production!
              // alert('Retry size!');
              this.sizeItems();
            }

          }
          // final row
          this.sizeElements(lastRow, maxH);

          sized = true;
        },
        50);

    }

    if (document.getElementById('curvetext')) {
      setTimeout(
        () => {

          const d: HTMLElement | null = document.getElementById('curvetext');
          const dw: number = d ? d.offsetWidth : 0;
          console.log(dw);
          const ct: any = new CircleType(document.getElementById('curvetext'))
            .dir(-1)
            .radius(dw === 200 ? 95 : 70);

          const ctdiv: any = document.getElementById('curvetext');
          ctdiv.classList.add('showcircle');
        },
        100);
    }
  }

}

const courseJs = new Course();

const hasSiema: boolean = document.getElementsByClassName('quotes-siema').length > 0;
if (hasSiema) {
  courseJs.quoteFunctions.setupSiema();
}

// indexJs.inviteFunctions.setupModal();
courseJs.inviteFunctions.setupTrial();
courseJs.inviteFunctions.setupForm();
courseJs.inviteFunctions.initialise(false);
courseJs.cookieFunctions.setupMessage();
courseJs.setupResizeListener();
courseJs.setupTouchListener();
courseJs.analytics();
courseJs.sizeItems();
